import React, { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

const MIN_HEIGHT = 800; // Your min target

// 1. The Context remains the same
const ScaleContext = createContext({ scale: 1 });

// 2. Renamed the component to ScaleProvider for clarity
export function ScaleProvider({ children }: { children: ReactNode }) {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const update = () => {
      const vh = window.innerHeight;
      setScale(vh < MIN_HEIGHT ? vh / MIN_HEIGHT : 1);
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  // This value will be "broadcast" to all children
  const value = useMemo(() => ({ scale }), [scale]);

  const wrapperStyle: React.CSSProperties = useMemo(
    () => ({
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    }),
    []
  );

  const innerStyle: React.CSSProperties = useMemo(
    () => ({
      width: `calc(100% / ${scale})`,
      height: `calc(100% / ${scale})`,
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
    }),
    [scale]
  );

  // 3. ✨ THE FIX: Wrap the children in the provider and pass the calculated value
  return (
    <ScaleContext.Provider value={value}>
      <div style={wrapperStyle}>
        <div style={innerStyle}>{children}</div>
      </div>
    </ScaleContext.Provider>
  );
}

// 4. The hook for consuming the context remains the same
export const useScale = () => useContext(ScaleContext);